import { render, staticRenderFns } from "./WhereToBuy.vue?vue&type=template&id=d88e3682&"
import script from "./WhereToBuy.vue?vue&type=script&lang=ts&"
export * from "./WhereToBuy.vue?vue&type=script&lang=ts&"
import style0 from "./WhereToBuy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports